const t = "$tenants";
export {
  t as TENANT_OBJECT_COLLECTION
};
//# sourceMappingURL=constants.mjs.map
